import { AccountCircle } from '@mui/icons-material';
import { Alert, Box, Card, Stack, Typography } from '@mui/material';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { useTranslation } from 'react-i18next';
import { useCallback, useRef } from 'react';
import { Colors } from 'src/shared/components/styles/colors';
import { useGlobals } from 'src/shared/contexts/appContext';
import { GroupMessageSmsPreviewTime } from './groupMessageSmsPreviewTime';
import { GroupMessageSmsPreviewChatBubble } from './groupMessageSmsPreviewChatBubble';
import { GroupMessageSmsPreviewStatusBar } from './groupMessageSmsPreviewStatusBar';

type GroupMessageSmsPreviewProps = {
  disabled: boolean;
  message: string;
  splitMessageLength: number;
};

export const GroupMessageSmsPreview = (props: GroupMessageSmsPreviewProps) => {
  const { disabled, message, splitMessageLength } = props;
  const { currentUser } = useGlobals();
  const { t } = useTranslation(['groupMessage']);

  // Make a reference to the top portion of the modal content
  // When an error occures, scroll top of modal into view
  const scrollArea = useRef<HTMLDivElement>(null);

  const splitMessage = useCallback(
    (str) => {
      const chunks: string[] = [];

      for (let i = 0, charsLength = str.length; i < charsLength; i += splitMessageLength) {
        chunks.push(str.substring(i, i + splitMessageLength));
      }

      return chunks;
    },
    [splitMessageLength],
  );

  const splittedMessages = splitMessage(message);

  return (
    <ContentSection header={t('Förhandsgranskning')}>
      <Card sx={{ backgroundColor: Colors.PageBackground, borderRadius: 3, p: 1, m: 0.5 }} elevation={2}>
        <GroupMessageSmsPreviewStatusBar sender={(currentUser && currentUser.customerName) || 'Avsändare'} />
        <Box sx={{ textAlign: 'center', px: 1, mt: 2 }}>
          <Typography variant='caption' sx={{ fontWeight: 500 }}>
            <GroupMessageSmsPreviewTime />
          </Typography>
        </Box>
        <Box sx={{ p: 2, pt: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', pr: 1 }}>
              <AccountCircle fontSize='medium' sx={{ color: (thm) => thm.palette.grey[600] }} />
            </Box>
            <Stack direction='column' spacing={1}>
              {splittedMessages?.map((x, index) => (
                <Alert
                  variant='filled'
                  severity='info'
                  icon={false}
                  sx={{ color: 'white', borderRadius: 3, wordBreak: 'break-all' }}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${x}${index}`}
                >
                  {x}
                </Alert>
              ))}
              {!disabled && <GroupMessageSmsPreviewChatBubble />}
              <Box ref={scrollArea} />
            </Stack>
          </Box>
        </Box>
      </Card>
    </ContentSection>
  );
};
